import { render, staticRenderFns } from "./badgeColumnRenderer.vue?vue&type=template&id=c58b65fa&"
import script from "./badgeColumnRenderer.vue?vue&type=script&lang=js&"
export * from "./badgeColumnRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/c/Users/tes028/source/Tesfri/logistic-variant-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c58b65fa')) {
      api.createRecord('c58b65fa', component.options)
    } else {
      api.reload('c58b65fa', component.options)
    }
    module.hot.accept("./badgeColumnRenderer.vue?vue&type=template&id=c58b65fa&", function () {
      api.rerender('c58b65fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/shared/components/generic/list/renderer/badgeColumnRenderer.vue"
export default component.exports